import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, CheckCircle2 } from 'lucide-react';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
export function PricingSection() {
  return <section id="pricing" className="py-8 md:py-10 bg-cream relative" data-id="element-220">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-221">
        {/* Urgency Banner */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-5" data-id="element-222">
          <div className="inline-flex items-center gap-2 bg-coral/10 text-coral-dark px-4 py-1.5 rounded-full font-bold text-sm uppercase tracking-wider mb-3" data-id="element-223">
            ⏳ ESTA OFERTA CIERRA EN:
          </div>
          <Countdown data-id="element-224" />
          <p className="text-dark-light mt-2 flex items-center justify-center gap-2 font-medium text-sm" data-id="element-225">
            <span className="text-xl" data-id="element-226">⚠️</span> Después aumenta a su precio
            regular.
          </p>
        </motion.div>

        {/* Pricing Card */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-[2.5rem] shadow-xl border-4 border-coral overflow-hidden relative" data-id="element-227">
          {/* Badge */}
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 bg-coral text-white font-bold px-8 py-2 rounded-b-2xl text-sm md:text-base whitespace-nowrap z-10" data-id="element-228">
            ⭐ EL MÁS ELEGIDO
          </div>

          <div className="p-4 md:p-6 pt-7" data-id="element-229">
            <div className="text-center mb-4" data-id="element-230">
              <span className="text-coral text-xs font-bold uppercase tracking-wider" data-id="element-231">
                🔴 ELEGÍ TU PACK — OFERTA DE LANZAMIENTO
              </span>
              <h3 className="md:text-2xl font-display font-bold text-dark mt-1 mb-1 text-[18px]" data-id="element-232">
                🧠 PACK BIENESTAR INTEGRAL
              </h3>
              <p className="text-dark-light font-medium text-sm" data-id="element-233">
                Libro Completo (Liz Kelly) + 4 Bonos Estratégicos
              </p>
            </div>

            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-1.5 mb-4 max-w-2xl mx-auto" data-id="element-234">
              {['BONO 1: Diario de Ruta (Workbook)', 'BONO 2: Botiquín de Emergencia', 'BONO 3: Plantillas para Poner Límites', 'BONO 4: Acceso a Comunidad Privada'].map((item, index) => <li key={index} className="flex items-center gap-[5px]" data-id="element-235">
                  <CheckCircle2 className="w-4 h-4 text-teal flex-shrink-0" data-id="element-236" />
                  <span className="text-dark font-medium text-xs" data-id="element-237">{item}</span>
                </li>)}
            </ul>

            <div className="text-center mb-4 bg-cream p-3 rounded-2xl max-w-md mx-auto" data-id="element-238">
              <p className="text-dark-light font-medium mb-0.5 text-xs" data-id="element-239">
                Precio Regular: <span className="line-through" data-id="element-240">$49.999</span>
              </p>
              <div className="flex items-center justify-center gap-2" data-id="element-241">
                <span className="text-xl" data-id="element-242">🔥</span>
                <p className="text-3xl font-display font-bold text-coral" data-id="element-243">
                  $19.999 <span className="text-base text-coral-dark" data-id="element-244">ARS</span>
                </p>
              </div>
              <p className="text-xs text-dark-light mt-0.5 font-medium" data-id="element-245">
                (Pago único)
              </p>
            </div>

            <div className="max-w-md mx-auto" data-id="element-246">
              <Button className="w-full text-base py-3.5 mb-2 shadow-xl" data-id="element-247">
                👉 🧠 QUIERO EL PACK BIENESTAR INTEGRAL
              </Button>

              <div className="flex items-center justify-center gap-2 text-xs text-dark-light font-medium text-center" data-id="element-248">
                <ShieldCheck className="w-4 h-4 text-teal flex-shrink-0" data-id="element-249" />
                <span data-id="element-250">
                  Pago seguro · Acceso inmediato al mail · Garantía 7 días
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}